import TyReplyList from './TyReplyList.vue'
export default TyReplyList



// WEBPACK FOOTER //
// ./src/components/ty-reply-list/index.js